export const getName = (user: any, isProfile = false) => (
  isProfile ? "me" : user.name?.split(" ", 1)[0]
);

export default getName;
